import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { getActas } from "./handlers";

import {
    Container,
    ContainerScreenGeneral,
    MuniSpinner2,
    ScreenHeader,
    Table,
} from "../../../components";

import { isAfter, isBefore, parseISO, subDays, addDays } from "date-fns";

import { CSVLink } from "react-csv";
// import excelLogo from '../../assets/excel-logo.png'
import { IconButton, Tooltip } from "@mui/material";
import { Button, Form } from "react-bootstrap";
import { tableData } from "./tableData";
import useActas from "../../../api/actas";
import { useActasStore } from "../../../store/actasStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import FilterBar from "../../../components/FilterBar";

// import notificadores from '../../../data/notificadores.json';
import useNotificadores from "../../../api/notificadores";
import { useNotificadoresStore } from "../../../store/notificadoresStore";
import ModalActaDetalle from "../../../views/modals/ModalActaDetalle";
import BadgeEstados from "../../../components/BadgeEstado";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";

const ActasSinBeneficio = () => {
    const { getNotificadores } = useNotificadores();
    const { notificadores } = useNotificadoresStore();
    const { asignarActasANotificador } = useActas();
    const  {setColeccionActasDetalle } = useActaDetalleStore();

    const location = useLocation();
    const { quitarNotificadorAsignado, getActaDetalle } = useActas();
    const [notificador, setNotificador] = useState();
    const [actasAsignar, setActasAsignar] = useState([]);

    const headers = [
        { label: "ID", key: "id" },
        { label: "#Acta", key: "numero_infraccion" },
        { label: "Infraccion", key: "tipo" },
        { label: "Patente", key: "plate" },
        { label: "Localidad", key: "localidad" },
        { label: "Documento", key: "documento_titular" },
    ];

    const { actas, setActas, actasFilter, setActasFilter, codigosZonales, codigosForaneos,
        actasDetalle,
        setActaDetalle,
        setActasDetalle,
        setActaAImprimir
    } = useActasStore();
    const { loads, handlerModal } = useGeneralAppStore();
    const { getActas } = useActas();

    const [filtros, setFiltros] = useState({
        tipo: "",
        localidad: "",
        fecha_desde: "",
        fecha_hasta: "",
        codigo_postal: "",
        zonales: "",
        search: "",
    });

    useEffect(() => {
        getActas("/actas_sin_beneficios");
        return () => {
            setActas(null);
            setActasFilter(null);
            setActasDetalle([]);
            setColeccionActasDetalle([])
        };
    }, []);

    // console.log(filtros);

    useEffect(() => {
        const actasFiltrados = actas?.filter((acta) => {
            let isInRage = true;
            const fecha = parseISO(acta.fecha_hora.split(" ")[0].split("/").reverse().join("-"));
            const fechaDesde = parseISO(filtros.fecha_desde);
            const fechaHasta = parseISO(filtros.fecha_hasta);
            const ajustarFechaDesde = subDays(fechaDesde, 1);
            const ajustarFechaHasta = addDays(fechaHasta, 1);
            if (filtros.fecha_desde != "" && filtros.fecha_hasta != "") {
                isInRage = isAfter(fecha, ajustarFechaDesde) && isBefore(fecha, ajustarFechaHasta);
            }

            if (filtros.fecha_desde != "" && filtros.fecha_hasta == "") {
                isInRage = isAfter(fecha, ajustarFechaDesde);
            }

            if (filtros.fecha_desde == "" && filtros.fecha_hasta != "") {
                isInRage = isBefore(fecha, ajustarFechaHasta);
            }

            let pepe = codigosForaneos;
            if (filtros.zonales != "" && filtros.zonales == "zonales") {
                pepe = codigosZonales;
            }

            if (
                // acta.codigo_postal?.includes(filtros.codigo_postal) &&
                // acta.localidad?.includes(filtros.localidad) &&
                (filtros.zonales != "" ? pepe.includes(acta.codigo_postal) : true) &&
                acta.tipo?.includes(filtros.tipo) &&
                isInRage &&
                (
                    acta.plate?.toLowerCase().includes(filtros.search.toLowerCase()) ||
                    acta?.numero_acta?.toString().toLowerCase().includes(filtros.search.toLowerCase()) ||
                    acta?.documento_titular?.toString().toLowerCase().includes(filtros.search.toLowerCase())
                )
            ) {
                return acta;
            }
        });
        setActasFilter(actasFiltrados);
    }, [filtros]);

    const asignarActas = () => {
        asignarActasANotificador({
            user_id_asignado: notificador,
            actas: actasAsignar,
        });
    };

    // console.log(notificador)
    // console.log(actasAsignar)
    // console.log(notificadores)
    // console.log(actasFilter)

    return (
        <ContainerScreenGeneral titulo={"Actas sin beneficio de pago voluntario"} linkBack={"/"} size={"full"}>
            {/* <ScreenHeader screenHeaderTitle={location.pathname === '/actas-notificadas' ? "Notificadas" : "Infracciones a notificar"} /> */}
            {/* {isLoading ? ( */}
            {loads.includes("actas") || loads.includes("notificadores") ? (
                <MuniSpinner2 />
            ) : (
                <>
                    {actasFilter && (
                        // ver de meter store de zustand. Tener dos estados actas y actasFiltradas.
                        <div className="position-relative">
                            {(loads.includes("asignar_notificador") || loads.includes('acta_detalle')) && (
                                <div
                                    className="w-100 h-100 d-flex justify-content-center align-items-center z-3 position-absolute"
                                    style={{ backgroundColor: "rgba(255,255,255,0.7" }}
                                >
                                    <MuniSpinner2 />
                                </div>
                            )}
                            {/* <p>Filtros</p> */}
                            {/* <Table height={600} data={tableData(actas, location)} name="actas" search /> */}
                            <Table
                                data={tableData(actasFilter, location, actasAsignar, setActasAsignar, notificador, getActaDetalle,
                                    actasDetalle,
                                    setActaDetalle,
                                    handlerModal, setActaAImprimir)}
                                name="actas"
                                search
                                excel={() => (
                                    <Tooltip title="Descargar tabla" arrow>
                                        <div className="h-100 d-flex align-items-center ps-3">
                                            <CSVLink
                                                style={{ textDecoration: "none" }}
                                                headers={headers}
                                                filename={"listado-actas.csv"}
                                                data={actasFilter}
                                                separator={";"}
                                                disabled={loads?.includes("actas")}
                                            >
                                                <IconButton>
                                                    {/* <div className='btn btn-light d-flex gap-2 align-items-center my-auto me-1' style={{ maxHeight: "38px" }}> */}
                                                    {/* <span style={{ color: "#111", textDecoration: "nome" }}>Descargar Listado</span> */}
                                                    <img
                                                        src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
                                                        alt="excel"
                                                        style={{ height: 25 }}
                                                    />
                                                </IconButton>
                                                {/* </div> */}
                                                {/* <img src={excelLogo} alt="excel-logo" /> */}
                                            </CSVLink>
                                        </div>
                                    </Tooltip>
                                )}
                                render={() => (
                                    <div className="d-flex justify-content-between align-items-center   w-100 px-5 py-3 gap-2 position-relative">
                                        <BadgeEstados estado="SIN BENEFICIO PAGO VOLUNTARIO" size="lg" />
                                        <div className="d-flex justify-content-between">
                                            <FilterBar filtros={filtros} setFiltros={setFiltros} />
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    )}
                </>
            )}
            <ModalActaDetalle type={'acta_incompleta'} />
        </ContainerScreenGeneral>
    );
};
export default ActasSinBeneficio;
